import siFetch from "api/fetch";

import handleParams from "api/handle-params";

const balanceRecord = (params = "", init = null) =>
  siFetch(`/api/v1/asset/balance_record${handleParams(params)}`, init);

export default balanceRecord;
